import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Tabs, Tab } from 'Core/components';
import MachinesAddEditForm from './machine-details-add-edit-form';
import CustomPropTypes from 'Core/prop-types';
import { AppModal } from '../components/app-modals';
import { showToast } from 'Core/redux/toast/slice';
import MaintenanceHistory from './maintenance-history';
import SafetyChecklist from './safety-checklist';
import CellHistory from './cell-history';
import SafetyChecklistHistory from './safety-checklist-history';
import EditMachine from './edit-machine';

const saveKeys = ['changed', 'id', 'isDeleted', 'userId'];

const editKeys = ['changed', 'isDeleted'];
const MachinesAddEdit = ({ showModal, modalData, onCloseModal }) => {
  const machinesData = modalData;
  const focusedTabIndex = Number(machinesData?.focusedTabIndex);
  const focusedMaintenanceId = machinesData?.focusedMaintenanceId;
  const [formData, setFormData] = useState(machinesData || null);
  const [cellData, setCellData] = useState(null);
  const [safetyData,setSafetyData]= useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(
    Number.isFinite(focusedTabIndex) && focusedTabIndex >= 0 ? focusedTabIndex : 0,
  );

  const dispatch = useDispatch();
  const isEditMode = Boolean(machinesData?.id);

  useEffect(() => {
    if (!machinesData) {
      return;
    }
    const machineFields = { ...machinesData };
    delete machineFields.focusedMaintenanceId;
    delete machineFields.focusedWorkOrderNumber;
    delete machineFields.focusedTabIndex;
    setFormData(prev => ({ ...(prev || {}), ...machineFields }));
  }, [machinesData]);

  const onChangesMachinesForm = data => {
    setFormData(data);
  };

  const onCellHistoryActionClick = (data, mode) => {
    setCellData({ data: data, mode: mode });
    setActiveTabIndex(1);
  };

  const onSafetyChecklistHistActionClick = (data, mode) => {
    setSafetyData({ mode: mode });
    setActiveTabIndex(3);
  };

  const handleTabChange = (newTabIndex) => {
    if (activeTabIndex === 1 && newTabIndex !== 1) {
      setCellData(null);
    }

    if (activeTabIndex === 3 && newTabIndex !== 3) {
      setSafetyData(null);
    }
    setActiveTabIndex(newTabIndex);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <div className="row">
        {isEditMode && (
          <Tabs activeIndex={activeTabIndex} onTabChange={handleTabChange}>
            <Tab title="Edit Machine">
              <EditMachine
                data={formData}
                onChanges={onChangesMachinesForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Machine Maintenance Details">
              <MachinesAddEditForm
                data={formData}
                isEditMode={true}
                cellActionRecord={cellData}
                onChanges={onChangesMachinesForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Maintenance Records History">
              <MaintenanceHistory
                data={formData}
                machineId={formData?.id}
                focusedMaintenanceId={focusedMaintenanceId}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist">
              <SafetyChecklist machineId={formData.id}
               onCloseModal={handleClose}
               safetyActionRecord={safetyData}
                />
            </Tab>
            <Tab title="Cell History">
              <CellHistory
                assetNumber={formData.assetNumber}
                onActionClick={onCellHistoryActionClick}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist History">
              <SafetyChecklistHistory
                data={formData}
                onChanges={onChangesMachinesForm}
                onCloseModal={handleClose}
                machineId={formData.id}
                onActionClick={onSafetyChecklistHistActionClick}
              />
            </Tab>
          </Tabs>
        )}
        {!isEditMode && (
          <EditMachine
            data={formData}
            onChanges={onChangesMachinesForm}
            onCloseModal={handleClose}
          />
        )}
      </div>
    );
  };

  const valid = () => {
    const ignoreKeys = isEditMode ? editKeys : saveKeys;
    if (
      !formData ||
      Object.keys(formData).some(key => {
        return !ignoreKeys.includes(key) && !formData[key];
      })
    ) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  return (
    <Modal
      id="machines-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Machine Maintenance Summary' : 'Add Machines'}
      body={body}
      handleClose={handleClose}
    />
  );
};

MachinesAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.Machines),
  onCloseModal: PropTypes.func,
};

export default AppModal(MachinesAddEdit);
